


































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { ContractDetails } from '@/models/contracts/ContractDetails';
import { CarrierLookup } from '@/models/carriers/CarrierLookup';
import { ApproveContractRequest } from '@/models/contracts/ApproveContractRequest';
import CarriersSearchRequest from '@/models/requests/CarriersSearchRequest';

import contractService from '@/services/ContractService';
import miscService from '@/services/MiscService';
import routeService from '@/services/RouteService';
import domService from '@/services/DOMService';
import carrierService from '@/services/CarrierService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      loading: false,
      snackbar: false,
      snackbarText: null,
      carrier: null as CarrierLookup,
      showUpdateDatesWindow: false,
      approving: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      contractService
        .getById(this.contractId)
        .then((x: ContractDetails) => {
          this.$store.commit('tmsContracts/setCurrentContract', x);
          this.loadCarrierDetails(x?.scac);
        })
        .finally(() => {
          this.loading = false;
        });

      contractService.getVerifiedTariffs(this.contractId).then((x: any) => {
        this.$store.commit('tmsContracts/setVerifiedTariffs', x);
      });

      contractService.getVerifiedFAKs(this.contractId).then((x: any) => {
        this.$store.commit('tmsContracts/setVerifiedFAKs', x);
      });

      contractService
        .getVerifiedAccessorials(this.contractId)
        .then((x: any) => {
          this.$store.commit('tmsContracts/setVerifiedAccessorials', x);
        });

      contractService.getVerifiedFuel(this.contractId).then((x: any) => {
        this.$store.commit('tmsContracts/setVerifiedFuel', x);
      });

      contractService.getServiceExceptions(this.contractId).then((x: any) => {
        this.$store.commit('tmsContracts/setServiceExceptions', x);
      });

      contractService.getServicePriority(this.contractId).then((x: any) => {
        this.$store.commit('tmsContracts/setServicePriority', x);
      });
    },
    loadCarrierDetails(scac: string) {
      const params = new CarriersSearchRequest();
      params.scac = scac;
      carrierService.search(params).then((x: CarrierLookup[]) => {
        if (x?.length) {
          this.carrier = x[0];
        }
      });
    },
    backToPrevPage() {
      miscService.goBack();
    },
    copyId() {
      domService.copyToClipboard(this.contractId);

      this.snackbarText = 'Contract ID has been copied to your clipboard';
      this.snackbar = true;
    },
    showUpdateDatesPopup() {
      this.showUpdateDatesWindow = true;
    },
    datesSaved() {
      contractService.getById(this.contractId).then((x: ContractDetails) => {
        this.$store.commit('tmsContracts/setCurrentContract', x);
      });
      this.showUpdateDatesWindow = false;

      this.snackbarText = 'Contract dates has been updated successfully';
      this.snackbar = true;
    },
    parametersUpdated() {
      this.snackbarText = 'Contract parameters have been updated successfully';
      this.snackbar = true;
    },
    documentsUpdated() {
      this.snackbarText = 'Contract documents have been updated successfully';
      this.snackbar = true;
    },
    approveContract() {
      const request = new ApproveContractRequest();
      request.contractId = this.contractId;
      request.approvedBy = this.displayEmail;

      this.approving = true;
      contractService
        .approveContract(request)
        .then(() => {
          this.snackbarText = 'Contract has been approved successfully';
          this.snackbar = true;
          this.init();
        })
        .finally(() => {
          this.approving = false;
        });
    },
  },
  computed: {
    ...mapGetters('tmsContracts', ['contractToEdit']),
    contractId() {
      return routeService.getValue(this, 'contractId');
    },
    contract() {
      return this.contractToEdit;
    },
    showApproveContractAlert() {
      return !this.contract?.approved;
    },
  },
});
